// Shown when a tour opened with ?avatar=play can't start the AI guide on its
// own (browser blocks sound without a click, or the microphone has not been
// allowed yet). One clear button, so the visitor knows what the click does —
// the click itself is the gesture the browser needs.
export default class AvatarStartPopup {
  constructor({ name = '', translateService = null, onStart, onDismiss } = {}) {
    this._onStart = onStart;
    this._onDismiss = onDismiss;
    this._t = (key, fallback) => {
      if (!translateService) return fallback;
      const val = translateService.translate(key);
      return (val && val !== key) ? val : fallback;
    };
    this._build(name);
  }

  _build(name) {
    const overlay = document.createElement('div');
    overlay.className = 'leadgen avatar-start';

    const backdrop = document.createElement('div');
    backdrop.className = 'leadgen__backdrop';
    backdrop.addEventListener('click', () => this._dismiss());

    const container = document.createElement('div');
    container.className = 'leadgen__container avatar-start__container';
    container.addEventListener('click', (e) => e.stopPropagation());

    const title = document.createElement('h3');
    title.className = 'leadgen__title';
    title.textContent = name
      ? this._t('AVATAR_START_TITLE_NAME', 'Hi {name}, your AI guide is ready').replace('{name}', name)
      : this._t('AVATAR_START_TITLE', 'Your AI guide is ready');

    const text = document.createElement('p');
    text.className = 'avatar-start__text';
    text.textContent = this._t('AVATAR_START_TEXT',
      'Press Start to walk through this property with your guide. Ask anything out loud — your browser will ask to use the microphone.');

    const actions = document.createElement('div');
    actions.className = 'leadgen__actions avatar-start__actions';

    const later = document.createElement('button');
    later.type = 'button';
    later.className = 'avatar-start__later';
    later.textContent = this._t('AVATAR_START_LATER', 'Not now');
    later.addEventListener('click', () => this._dismiss());

    const start = document.createElement('button');
    start.type = 'button';
    start.className = 'btn eyespy-btn-secondary avatar-start__button';
    start.textContent = this._t('AVATAR_START_BUTTON', 'Start');
    // Synchronous handler: the start must run inside the click (iOS audio unlock).
    start.addEventListener('click', () => {
      this.destroy();
      if (typeof this._onStart === 'function') this._onStart();
    });

    actions.append(later, start);
    container.append(title, text, actions);
    overlay.append(backdrop, container);
    document.body.appendChild(overlay);
    this._overlay = overlay;
    start.focus();
  }

  _dismiss() {
    this.destroy();
    if (typeof this._onDismiss === 'function') this._onDismiss();
  }

  destroy() {
    if (this._overlay) this._overlay.remove();
    this._overlay = null;
  }
}
